let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8y3F9")).then(() => parcelRequire('hDcr6'));